import { useState, useMemo } from 'react';

export default function useFrontShopForm() {
  const [category, setCategory] = useState('');
  const [customCategory, setCustomCategory] = useState('');
  const [shelve, setShelve] = useState('A1');
  const [packSize, setPackSize] = useState(0);
  const [productName, setProductName] = useState('');
  const [reorderLevel, setReorderLevel] = useState(0);
  const [quantity, setQuantity] = useState(0);
  const [costPrice, setCostPrice] = useState('');
  const [manufacturer, setManufacturer] = useState('');
  const [barcode, setBarcode] = useState('');
  const [supplier, setSupplier] = useState('');
  const [supplierCode, setSupplierCode] = useState('');
  const [invoiceNumber, setInvoiceNumber] = useState('');
  const [note, setNote] = useState('');

  const resetForm = () => {
    setProductName('');
    setPackSize(0);
    setShelve('A1');
    setReorderLevel(0);
    setQuantity(0);
    setCostPrice('');
    setManufacturer('');
    setBarcode('');
    setSupplier('');
    setSupplierCode('');
    setInvoiceNumber('');
    setNote('');
    setCategory('');
    setCustomCategory('');
  };

  const parsedCost = useMemo(() => Number(String(costPrice).replace(/[^0-9.\-]/g, '')) || 0, [costPrice]);

  return {
    category, setCategory,
    customCategory, setCustomCategory,
    shelve, setShelve,
    packSize, setPackSize,
    productName, setProductName,
    reorderLevel, setReorderLevel,
    quantity, setQuantity,
    costPrice, setCostPrice, parsedCost,
    manufacturer, setManufacturer,
    barcode, setBarcode,
    supplier, setSupplier,
    supplierCode, setSupplierCode,
    invoiceNumber, setInvoiceNumber,
    note, setNote,
    resetForm,
  };
}
